import {AppsyncService} from './AppsyncService'
import gql from "graphql-tag";
import {oktaAuth} from "../config/OktaConfig";
import {getRetriggers} from "../../graphql/retrigger-appsync-endpoint/queries";
import {doRetrigger} from "../../graphql/retrigger-appsync-endpoint/mutations";

export class RetriggerService {

    appsyncService : AppsyncService;

    constructor() {
        this.appsyncService = new AppsyncService(process.env.REACT_APP_APPSYNC_RETRIGGER_ENDPOINT!, oktaAuth)
    }

    async getRetriggers(traceId: string): Promise<any> {
        return this.appsyncService.appSyncClient.query({
                query: gql(getRetriggers), fetchPolicy: 'network-only', variables: {
                    traceId: traceId
                }
            }
        );
    }

    async doRetrigger(traceId: string): Promise<any> {
        return this.appsyncService.appSyncClient.mutate({
            mutation: gql(doRetrigger), fetchPolicy: 'no-cache', variables: {
                traceId: traceId
            }
        });
    }

}